import { ExperimentGetter, PageHeaderContext } from 'frontend/types';

// Note: this experiment was initially called premium_referrals_03_2021. We updated the name
// to change the treatments in the admin while keeping code changes to a minimum.
export const experimentName = 'premium_referrals_10_2021';

/**
 * This is effectively an enum, but using the "objects-vs-enums" approach described here:
 * https://www.typescriptlang.org/docs/handbook/enums.html#objects-vs-enums
 * The reason for this is that we want to *both* treat these as types, as well as be able to
 * index into this structure with string keys. This approach allows us to do both:
 * - index into this object when we need the actual string value for something;
 * - use the values as type variants
 *   (see the type declaration for PremiumReferrals102021Treatment)
 */
export const premiumReferrals102021Treatments = {
  control: 'control',
  credit_on_subscribe: 'credit_on_subscribe',
} as const;

/**
 * This is equivalent to
 * type PremiumReferrals102021Treatment = 'control' | 'credit_on_subscribe' | ...
 * for all values of premiumReferrals102021Treatments.
 */
export type PremiumReferrals102021Treatment =
  (typeof premiumReferrals102021Treatments)[keyof typeof premiumReferrals102021Treatments];

export function premiumReferrals102021ActiveTreatment(
  experimentGetter: ExperimentGetter,
): PremiumReferrals102021Treatment {
  // Find which treatment is the active one. If we don't find one, use control as fallback.
  const result: PremiumReferrals102021Treatment | undefined = Object.values(
    premiumReferrals102021Treatments,
  ).find(t => experimentGetter(experimentName, t));
  return result || premiumReferrals102021Treatments.control;
}

export function shouldHideMonthlyPlansFromPaywall(context: PageHeaderContext): boolean {
  return referrerCreditAvailable(context);
}

export function referrerCreditAvailable(context: PageHeaderContext): boolean {
  // Returns true if a Referrer Credit is available. As in, this person has referred someone and
  // received credit for their conversion.
  const freeMonths = context?.referral_context?.referrer_credit?.free_months;
  return freeMonths !== undefined && freeMonths > 0;
}
